/**
 * component to render in nominations tab at How to Nominate page SBA
 */
const Nominations = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 px-5 py-4 font-public-sans"
      data-testid="nominations-component"
    >
      <p>
        Nominations for <strong>Singapore Business Awards 2026</strong> are now
        open.
      </p>

      <p>
        <strong>Individual Awards — Nomination Guidelines</strong>
      </p>

      <p>Please submit a dossier of the nominated individual that includes:</p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>
          Background information (education, career history, achievements)
        </li>
        <li>Key achievements and contributions</li>
        <li>ESG-related efforts (if any)</li>
      </ul>

      <p>Dossier Requirements:</p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Maximum 4 pages, font size 12</li>
      </ul>

      <p>Must include:</p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Recent photo</li>
        <li>Current designation</li>
        <li>Age</li>
        <li>
          Additional relevant information may be included, within the page limit
        </li>
      </ul>

      <p>
        <strong>Enterprise Award — Nomination Guidelines</strong>
      </p>

      <p>For Enterprise Award nominations, the dossier should cover:</p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Company overview & development</li>
        <li>Outstanding business performance</li>
        <li>Notable achievements</li>
        <li>ESG-related efforts (if any)</li>
      </ul>

      <p>Dossier Requirements:</p>

      <ul className="list-outside list-disc pb-6 pl-8">
        <li>Maximum 4 pages, font size 12</li>
        <li>
          Additional relevant information may be included, within the page limit
        </li>
      </ul>

      <p>
        <strong>Submission Details</strong>
      </p>

      <p>
        Please email all completed nomination dossiers by{" "}
        <strong>
          15 December 2025 to{" "}
          <a href="mailto:yufanong@sph.com.sg" className="text-blue-175">
            yufanong@sph.com.sg
          </a>
          .
        </strong>
      </p>

      <p>
        For enquiries, kindly contact Ong Yu Fan via email (
        <a href="mailto:yufanong@sph.com.sg" className="text-blue-175">
          yufanong@sph.com.sg
        </a>
        ).
      </p>

      <p>We look forward to receiving your nominations.</p>

      <p>Thank you.</p>
    </div>
  );
};

export default Nominations;
